/* eslint-disable no-unused-vars */
import { ArrowBack, ArrowForward, Save } from '@mui/icons-material'
import { Box, CircularProgress, Divider, useMediaQuery } from '@mui/material'
import { ProposalFlowActionDropdown, PropsWithWizard } from '~/components'
import { useProposalContext } from '~/contexts'
import { Button } from '~/components/Form/Button'
import { EProposalStatus } from '~/graphql/types'
import { usePermission } from '~/hooks'
import { theme } from '~/utils'

export type ActionButtonsProps = {
  loading: boolean
  onSubmit: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>
}
export const ActionButtons: React.FC<PropsWithWizard<ActionButtonsProps>> = (props) => {
  const { proposal } = useProposalContext()
  const { onPrev, loading, onSubmit, onNext } = props

  const disableFields = proposal?.status !== EProposalStatus.documentation
  const canEditProposal = usePermission(['proposals.updated'])
  const isLowerMd = useMediaQuery(theme.breakpoints.down('md'))
  const isLowerSm = useMediaQuery(theme.breakpoints.down('sm'))

  const handleSubmit = async (submitType: 'continue' | 'save') => {
    await onSubmit()

    if (submitType === 'continue') {
      onNext()
    }
  }

  return (
    <>
      <Divider sx={{ marginTop: 1, marginBottom: 1 }} />

      <Box sx={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex' }} >
        {!isLowerMd && (
          <Button disabled={loading} startIcon={<ArrowBack />} color='secondary' onClick={onPrev}>
            Voltar
          </Button>
        )}

        <Box sx={{ display: 'flex', flexDirection: isLowerSm ? 'column' : 'row', gap: 2, width: '100%' }}>
          <Box sx={{ display: 'flex', gap: 2, width: '100%', justifyContent: isLowerSm ? 'space-between' : 'flex-end' }}>
            <ProposalFlowActionDropdown disabled={loading || disableFields} proposal={proposal} />

            <Button
              onClick={() => handleSubmit('save')}
              disabled={loading || disableFields || !canEditProposal}
              startIcon={loading ? <CircularProgress size={24} color='inherit' /> : <Save />}
              color='secondary'
              size='small'
            >
            Gravar dados
            </Button>

          </Box>
          <Button
            fullWidth={isLowerSm}
            disabled={loading || disableFields || !canEditProposal}
            onClick={() => handleSubmit('continue')}
            endIcon={<ArrowForward />}
          >
            Continuar
          </Button>
        </Box>
      </Box>
    </>
  )
}
